import { useState } from 'react';

import { useAutoCheckOffTask } from 'src/app/pages/starterDashboardV2/shared/hooks';

import type { Template } from '../../../hooks/useDownloadFlyerModalBody/types';

type UseChooseFlyerTemplateFormReturn = ModelHookResult<
	{ disabled: boolean; loading: boolean },
	{
		downloadFlyerTemplate: (event: React.FormEvent<HTMLFormElement>) => Promise<void>;
		onInputChange: () => void;
	}
>;
export function useChooseFlyerTemplateForm(templates: Template[]): UseChooseFlyerTemplateFormReturn {
	const [disabled, setDisabled] = useState(true);
	const [loading, setLoading] = useState(false);
	const autoCheckOffTask = useAutoCheckOffTask();

	const onInputChange = () => {
		setDisabled(false);
	};
	const downloadFlyerTemplate = async (event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault();

		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		const selectedFlyer = new FormData(event.target as HTMLFormElement).get('flyer-templates');

		const selectedTemplateObject = templates.find((template) => template.name === selectedFlyer);

		// generate, download PDF + call share action tracking
		if (selectedTemplateObject) {
			setLoading(selectedTemplateObject.loading);
			const blob = await selectedTemplateObject.generate();
			if (blob) {
				const link = document.createElement('a');
				link.setAttribute('href', URL.createObjectURL(blob));
				link.setAttribute('download', selectedTemplateObject.filename);
				const clickEvent = new MouseEvent('click');
				link.dispatchEvent(clickEvent);
				link.remove();
				await selectedTemplateObject.track();
				await autoCheckOffTask('download_flyer');
			}
		}
	};

	return {
		data: { disabled, loading },
		actions: { downloadFlyerTemplate, onInputChange },
	};
}
